// 接送模式
export const transportModeDic = [
  { value: 1, label: '拼车' },
  { value: 2, label: '拼车和专享' }
]
export const transportModeDic2 = [
  { value: 1, label: '拼车' },
  { value: 2, label: '专享' }
]

export const getLabelByValue = (value, dicArr) => {
  if (!value || !Array.isArray(dicArr)) {
    return ''
  }
  const obj = dicArr.find((item) => parseInt(item.value) === parseInt(value))
  if (obj) {
    return obj.label
  }
  return ''
}
